import firebase from 'firebase/compat/app'
import "firebase/compat/firestore";
import "firebase/compat/auth";
import 'firebase/compat/database';
import 'firebase/compat/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

firebase.initializeApp(firebaseConfig);
// ローカル確認では本番のアクセス解析を送信しない。
if (process.env.NODE_ENV === 'production' &&
    !['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname)) {
  firebase.analytics();
}

export default firebase;
